module.exports = __webpack_public_path__ + "static/media/How to customize email link template for Update Visa Status Notification.3eb609ff.png";